import { graphql } from 'gatsby';
import React from 'react';
import { css } from 'styled-components';
import Box from '../../components/Box/Box';
import CollapseContainer from '../../components/CollapseContainer/CollapseContainer';
import WithSection from '../../components/WithSection/WithSection';
import {
    Body1,
    Body2,
    Head3,
    Headline,
} from '../../components/Typography/Typography';
import Divider from '../../components/Divider/Divider';
import { RichText } from 'prismic-reactjs';
import get from 'lodash/get';
import { theme } from '../../../config/theme';
import logosSection from '../LogosSection/LogosSection';

const FaqsThemeMap = {
    default: {
        border: 'primary.1800',
    },
    purple: {
        border: 'tertiary.purple.1300',
    },
};

const FAQSection = ({
    data: { primary, items },
    styling: { sectionTheme },
}) => {
    const { heading, subheading } = primary;
    const faqsTheme = FaqsThemeMap[sectionTheme];

    return (
        <Box gridColumn={{ _: '1/-1', lg: '2/-2' }}>
            <Head3 bold textAlign="center">
                {heading.text}
            </Head3>

            {subheading && (
                <Body1 mt="20px" textAlign="center">
                    {subheading}
                </Body1>
            )}
            <Box mt="40px">
                {items.map(({ answer, question }, i) => (
                    <Box key={i} marginBottom="30px">
                        <Divider color={get(theme.colors, faqsTheme.border)} />
                        <Box>
                            <CollapseContainer initiallyOpen={i === 0}>
                                <CollapseContainer.Header>
                                    <Box>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <Headline>{question}</Headline>
                                            <Box color="primary.main">
                                                <CollapseContainer.Arrow
                                                    size={40}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                </CollapseContainer.Header>

                                <CollapseContainer.Item>
                                    <Box marginTop="15px">
                                        <Body2>
                                            <RichText render={answer.raw} />
                                        </Body2>
                                    </Box>
                                </CollapseContainer.Item>
                            </CollapseContainer>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export const _ = graphql`
    fragment FAQ on PrismicFaqDefault {
        id
        primary {
            heading {
                text
            }
            subheading
        }
        items {
            question
            answer {
                raw
            }
        }
    }
`;

export default WithSection(FAQSection);
